import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { switchMap } from 'rxjs';

import { ExternalBetslipActions } from '../../core/external-betslip-actions';
import BetslipPickActions from '../picks/actions';
import { BetslipWebBridgeService } from './betslip-web-bridge.service';

@Injectable()
export default class BetslipWebBridgeEffects {
    constructor(
        private actions$: Actions,
        private webBridgeService: BetslipWebBridgeService,
    ) {}

    handleAddWebAppPickEffect$ = createEffect(() => {
        const effect = this;

        return this.actions$.pipe(
            ofType(BetslipPickActions.addWebAppPick),
            switchMap(function* (action): Iterable<Action> {
                const pick = effect.webBridgeService.getAddPickPayload(action.fixture, action.option);

                if (pick) {
                    yield ExternalBetslipActions.addPick(pick);
                }
            }),
        );
    });

    handleRemoveWebAppPickEffect$ = createEffect(() => {
        const effect = this;

        return this.actions$.pipe(
            ofType(BetslipPickActions.removeWebAppPick),
            switchMap(function* (action): Iterable<Action> {
                const pick = effect.webBridgeService.getRemovePickPayload(action.fixture, action.option);

                if (pick) {
                    yield ExternalBetslipActions.removePick({ pickId: pick });
                }
            }),
        );
    });
}
